module.exports = __webpack_public_path__ + "img/terms_conditions_bg.afb4ac8a.jpg";